module.exports = __webpack_public_path__ + "static/img/340.56506c4a.png";